import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
var AbstractMaskSystem = /*#__PURE__*/function () {
  function AbstractMaskSystem(renderer) {
    _classCallCheck(this, AbstractMaskSystem);
    this.renderer = renderer;
    this.maskStack = [];
    this.glConst = 0;
  }
  _createClass(AbstractMaskSystem, [{
    key: "getStackLength",
    value: function getStackLength() {
      return this.maskStack.length;
    }
  }, {
    key: "setMaskStack",
    value: function setMaskStack(maskStack) {
      var gl = this.renderer.gl;
      var curStackLen = this.getStackLength();
      this.maskStack = maskStack;
      var newStackLen = this.getStackLength();
      if (newStackLen !== curStackLen) {
        if (newStackLen === 0) {
          gl.disable(this.glConst);
        } else {
          gl.enable(this.glConst);
          this._useCurrent();
        }
      }
    }
  }, {
    key: "_useCurrent",
    value: function _useCurrent() {}
  }, {
    key: "destroy",
    value: function destroy() {
      this.renderer = null;
      this.maskStack = null;
    }
  }]);
  return AbstractMaskSystem;
}();
export { AbstractMaskSystem };